import { render, staticRenderFns } from "./TeoricasPorPeriodoModal.vue?vue&type=template&id=060048bd&scoped=true"
import script from "./TeoricasPorPeriodoModal.vue?vue&type=script&lang=js"
export * from "./TeoricasPorPeriodoModal.vue?vue&type=script&lang=js"
import style0 from "./TeoricasPorPeriodoModal.vue?vue&type=style&index=0&id=060048bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060048bd",
  null
  
)

export default component.exports